/** Notification helper */
var Notify = function () {

  /** Summary of info */
  this.summary = {
    timestamp: null
  };

  /** Set of most recently seen objects */
  this.recent = {};

  /** Set of urls to parse */
  this.urls = ['/shark-activity/twitter-feed?', '/shark-activity/detection-feed?'];

  /** Callback to invoke with a summary when things change */
  this.callback = null;

  /** Polling interval */
  this.interval = 15000;

  /** Last update timestamp */
  this.timestamp = {};

  /** Store smart_drumlines_active to prevent re-sending same value */
  this.smart_drumlines_active = undefined;

};

/** Clear the set of saved summary data */
Notify.prototype.clear = function (key) {
  if (key) {
    this.summary[key] = [];
    if (this.any() === 0) {
      this.summary = {
        timestamp: null
      };
      this.timestamp[key] = new Date();
    }
  } else {
    for (var v in this.summary) {
      this.clear(v);
    }
  }
};

/** Get bar timestamp for a key */
Notify.prototype.time = function (key) {
  return Math.floor(this.timestamp[key].getTime() / 1000);
};

Notify.prototype.getNowSeconds = function () {
  return Math.floor(new Date().getTime() / 1000);
};

/** Return count of items */
Notify.prototype.any = function () {
  var count = 0;
  for (var key in this.summary) {
    if (key !== 'timestamp') {
      if (this.summary[key]) {
        count += this.summary[key].length;
      }
    }
  }
  return count;
};

/** Watch for feed changes */
Notify.prototype.watch = function () {
  var self = this;
  var newest = {
    twitter: this.getNowSeconds(),
    detection: this.getNowSeconds(),
    sighting: this.getNowSeconds(),
    smart_drumline: this.getNowSeconds(),
  };
  var update = function () {
    var updated = false;
    self.poll(function (data) {
      var t = self.type(data);

      // Update the most recent change
      if (!newest[t]) {
        newest[t] = data.timestamp;
      } else if (data.timestamp > newest[t]) {
        newest[t] = data.timestamp;
      }

      // Process item if it's new
      if (data.timestamp > self.recent[t]) {
        self.handle(data);
        updated = true;
      }
    }, function () {
      // Update the timestamps
      for (var key in newest) {
        self.recent[key] = newest[key];
      }
      self.complete(updated);
    });
  };
  this.init();
  window.setInterval(update, self.interval);
};

/** Poll all the urls and return a record for each hit */
Notify.prototype.poll = function (callback, complete) {
  var self = this;
  var breakcache = new Date().getTime();
  var worker = function (data) {
    // Adjust for format changes on detection-feed
    if (data.feed) {
      // Fake a type for smart_drumlines_active changes
      if (data.hasOwnProperty('smart_drumlines_active') &&
        self.smart_drumlines_active !== data.smart_drumlines_active
      ) {
        self.smart_drumlines_active = data.smart_drumlines_active;
        if (self.smart_drumlines_active !== undefined) {
          callback({
            "summary_list": ["smart_drumlines_active"],
            "timestamp": (new Date()).getTime(),
            "activity_type_icon": "smart_drumline",
            "longitude": 114.975037, // Lat/Lng is required and around middle of drumline just in case
            "latitude": -33.853782,
            "value": self.smart_drumlines_active,
            "type": "smart_drumlines_active"
          });
        }
      }
      data = data.feed;
    }
    for (var i = 0; i < data.length; ++i) {
      callback(data[i]);
    }
    done += 1;
    if (done == self.urls.length) {
      if (complete) {
        complete();
      }
    }
  };
  for (var i = 0; i < self.urls.length; ++i) {
    var done = 0;
    $.ajax(self.urls[i] + 'date_range=' + $('.filter-time').val() + '&ie_cachebust=' + breakcache).done(worker);
  }
};

/** Get most recent items the first time round */
Notify.prototype.init = function () {
  var self = this;
  this.poll(function (data) {
    var t = self.type(data);
    if (!self.recent[t]) {
      self.recent[t] = data.timestamp;
    } else if (data.timestamp > self.recent[t]) {
      self.recent[t] = data.timestamp;
    }
  }, function () {
    if (!self.recent.twitter) {
      self.recent.twitter = self.getNowSeconds()
    }
    if (!self.recent.detection) {
      self.recent.detection = self.getNowSeconds()
    }
    if (!self.recent.sighting) {
      self.recent.sighting = self.getNowSeconds()
    }
    if (!self.recent.smart_drumline) {
      self.recent.smart_drumline = self.getNowSeconds()
    }

    self.timestamp.twitter = new Date();
    self.timestamp.detection = new Date();
    self.timestamp.sighting = new Date();
    self.timestamp.smart_drumline = new Date();
  });
};

/**
 * Handle updates to particular feed
 */
Notify.prototype.handle = function (data) {
  if (!this.summary[this.type(data)]) {
    this.summary[this.type(data)] = [];
  }

  // Generate a specific data set to save into the summary
  // based on type; specfically filter detections to only
  // new items in the summary.
  var ty = this.type(data);
  if (ty == "detection" || ty == "sighting" || ty == "smart_drumline") {
    for (var i = 0; i < data.list.length; ++i) {
      if (data.list[i][1].timestamp > this.recent[ty]) {
        this.summary[ty].push(data.list[i]);
      }
    }
  }

  // Otherwise push whatever into the array
  else {
    this.summary[ty].push(data);
  }

  // Reset timestamp.
  if (this.summary.timestamp === null) {
    this.summary.timestamp = new Date();
  }
};

/** Trigger a callback when complete */
Notify.prototype.complete = function (updated) {
  if (updated) {
    if (this.callback) {
      this.callback(this.summary);
    }
  }
};

/** Get the type from any object */
Notify.prototype.type = function (data) {
  if (data.type) {
    return data.type;
  }
  return 'twitter';
};

export default Notify;